/* Maison — page produit : lien "Guide des tailles" sur la ligne Taille + fenêtre compacte (tableau uniquement). */
(function () {
  function placeSizeGuide() {
    const link = document.querySelector('.product-information .popup-link');
    if (!link || link.dataset.maisonMoved) return;
    const legends = [...document.querySelectorAll('.product-information .variant-option legend')];
    const legend = legends.find((l) => /taille|size|pointure/i.test(l.textContent));
    if (!legend) return;
    legend.classList.add('maison-size-legend');
    link.classList.add('maison-size-guide');
    link.dataset.maisonMoved = '1';
    legend.appendChild(link);
    const btn = link.querySelector('button');
    if (btn) { btn.type = 'button'; btn.removeAttribute('on:click'); }
  }
  placeSizeGuide();
  new MutationObserver(placeSizeGuide).observe(document.querySelector('.product-information') || document.body, { childList: true, subtree: true });

  function sizeKeys(v) { var keys = []; String(v || '').split('/').forEach(function (part) { part = part.trim().toUpperCase().replace(/\*+$/, ''); if (!part) return; keys.push(part); var lead = part.split(/[\s(]/)[0]; if (lead && lead !== part) keys.push(lead); var m = part.match(/^(?:AU|EU|UK|US|FR|IT)\s*(\d+(?:\.\d+)?)$/); if (m) keys.push(m[1]); var n = part.replace(/[^0-9.]/g, ''); if (n) keys.push(n); }); return keys; }
  function rowMatches(set, cell) { return sizeKeys(cell).some(function (k) { return set.has(k); }); }
  let modal;
  function buildModal(source) {
    modal = document.createElement('dialog');
    modal.className = 'maison-sg';
    // tableau propre au produit (bloc .maison-size-chart dans la description) sinon tableau de la page guide
    var chart = document.querySelector('.maison-size-chart');
    var table = null;
    if (!chart && source) {
      // shoes without their own chart: use the page table that has a foot-length column, otherwise the first table
      var isShoe = [...document.querySelectorAll('.product-information .variant-option input[type="radio"]')].some(function (i) { return /^(AU|EU)\s*\d/i.test(i.value); });
      var tables = [...source.querySelectorAll('table')];
      table = (isShoe ? tables.find(function (t) { return /foot|EU/i.test(t.querySelector('thead') ? t.querySelector('thead').textContent : ''); }) : null) || tables[0] || null;
    }
    modal.innerHTML =
      '<div class="maison-sg__head"><h2 class="maison-sg__title">Size guide</h2><button type="button" class="maison-sg__close" aria-label="Close">&times;</button></div>' +
      '<p class="maison-sg__hint"></p>' +
      '<div class="maison-sg__table"></div>';
    if (chart) {
      var legendsC = [...document.querySelectorAll('.product-information .variant-option')].filter(function (f) { var l = f.querySelector('legend'); return l && /taille|size|pointure/i.test(l.textContent); });
      var sizesC = new Set();
      legendsC.forEach(function (f) { f.querySelectorAll('input[type="radio"], option, label, [data-option-value]').forEach(function (el) { var v = (el.value || el.dataset.optionValue || el.textContent || '').trim().toUpperCase(); if (v && v.length <= 20) sizeKeys(v).forEach(function (k) { sizesC.add(k); }); }); });
      chart.querySelectorAll('table, .maison-size-chart__title').forEach(function (el) {
        var c = el.cloneNode(true);
        if (sizesC.size && c.tagName === 'TABLE') c.querySelectorAll('tbody tr').forEach(function (tr) { var first = tr.querySelector('td'); if (first && !rowMatches(sizesC, first.textContent)) tr.remove(); });
        modal.querySelector('.maison-sg__table').appendChild(c);
      });
    }
    if (table) {
      var clone = table.cloneNode(true);
      // ne garder que les tailles proposées sur cette fiche produit
      var legends = [...document.querySelectorAll('.product-information .variant-option')].filter(function (f) { var l = f.querySelector('legend'); return l && /taille|size|pointure/i.test(l.textContent); });
      var sizes = new Set();
      legends.forEach(function (f) { f.querySelectorAll('input[type="radio"], option, label, [data-option-value]').forEach(function (el) { var v = (el.value || el.dataset.optionValue || el.textContent || '').trim().toUpperCase(); if (v && v.length <= 20) sizeKeys(v).forEach(function (k) { sizes.add(k); }); }); });
      if (sizes.size) clone.querySelectorAll('tbody tr, tr').forEach(function (tr) { var first = tr.querySelector('td'); if (first && !rowMatches(sizes, first.textContent)) tr.remove(); });
      modal.querySelector('.maison-sg__table').appendChild(clone);
      // CM / Inches tabs when the guide page has an inches table
      var inT = !isShoe && tables.find(function (t) { return t !== table && /\(IN\)/i.test(t.querySelector('thead') ? t.querySelector('thead').textContent : ''); });
      if (inT) {
        var inClone = inT.cloneNode(true);
        if (sizes.size) inClone.querySelectorAll('tbody tr').forEach(function (tr) { var first = tr.querySelector('td'); if (first && !rowMatches(sizes, first.textContent)) tr.remove(); });
        inClone.hidden = true;
        modal.querySelector('.maison-sg__table').appendChild(inClone);
        var units = document.createElement('div');
        units.className = 'maison-sg__units';
        units.innerHTML = '<button type="button" aria-pressed="true">CM</button><button type="button" aria-pressed="false">Inches</button>';
        units.addEventListener('click', function (e) { var u = e.target.closest('button'); if (!u) return; var isIn = u.textContent === 'Inches'; clone.hidden = isIn; inClone.hidden = !isIn; units.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === u)); }); });
        modal.querySelector('.maison-sg__table').before(units);
      }
    }
    var intro = chart ? chart.querySelector('p') : (table && table.previousElementSibling && table.previousElementSibling.tagName === 'P' ? table.previousElementSibling : (source ? source.querySelector('.rte p, .page-block p, p') : null));
    var hint = intro && intro.textContent.trim() ? intro.textContent.trim() : 'Body measurements in cm. Between two sizes, choose the larger.';
    modal.querySelector('.maison-sg__hint').textContent = hint;
    modal.querySelector('.maison-sg__close').addEventListener('click', () => modal.close());
    modal.addEventListener('click', (e) => { if (e.target === modal) modal.close(); });
    document.body.appendChild(modal);
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.product-information .popup-link button');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const source = btn.closest('.popup-link').querySelector('dialog');
    if (source && source.open) source.close();
    if (!modal) buildModal(source);
    modal.showModal();
    setTimeout(() => { if (source && source.open) source.close(); }, 50);
  }, true);
})();

/* Maison — pastilles couleur : vignettes nettes et plus grandes, nom de la couleur sous chaque vignette. */
(function () {
  function upgradeSwatches() {
    document.querySelectorAll('.product-information .variant-option__button-label--has-swatch').forEach(function (label) {
      var sw = label.querySelector('.swatch--variant-image');
      if (sw && !sw.dataset.maisonHd) {
        sw.dataset.maisonHd = '1';
        var bg = sw.style.getPropertyValue('--swatch-background');
        if (bg) sw.style.setProperty('--swatch-background', bg.replace(/width=\d+/, 'width=240'));
      }
      var input = label.querySelector('input[type="radio"]');
      if (input && !label.querySelector('.maison-swatch-name')) {
        var name = document.createElement('span'); name.className = 'maison-swatch-name'; name.textContent = input.value; label.appendChild(name);
      }
    });
  }
  upgradeSwatches();
  new MutationObserver(upgradeSwatches).observe(document.querySelector('.product-information') || document.body, { childList: true, subtree: true });
})();

/* Maison — product gallery on phones: true loop. A copy of the last photo peeks on the left of the first one,
   a copy of the first photo peeks after the last one, and swiping past either end jumps seamlessly. */
(function () {
  if (window.matchMedia('(min-width: 750px)').matches) return;
  var FLAG = 'maisonLooped';
  function centreOf(scroller, el) { return el.offsetLeft - (scroller.clientWidth - el.offsetWidth) / 2; }
  function makeClone(slide, which) {
    var c = document.createElement('div');
    c.className = 'maison-clone maison-clone--' + which;
    c.setAttribute('aria-hidden', 'true');
    c.innerHTML = slide.innerHTML;
    c.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });
    c.querySelectorAll('img').forEach(function (img) { img.loading = 'eager'; img.removeAttribute('ref'); });
    c.querySelectorAll('[ref]').forEach(function (n) { n.removeAttribute('ref'); });
    return c;
  }
  function setup(scroller) {
    if (scroller.dataset[FLAG]) return;
    var slides = [].slice.call(scroller.querySelectorAll(':scope > slideshow-slide')).filter(function (s) { return !s.hasAttribute('hidden'); });
    if (slides.length < 2) return;
    scroller.dataset[FLAG] = '1';
    var first = slides[0], last = slides[slides.length - 1];
    var head = makeClone(last, 'head'), tail = makeClone(first, 'tail');
    scroller.insertBefore(head, scroller.firstChild);
    scroller.appendChild(tail);
    var jump = function (el) { scroller.style.scrollBehavior = 'auto'; scroller.scrollLeft = centreOf(scroller, el); scroller.style.scrollBehavior = ''; };
    requestAnimationFrame(function () { jump(first); });
    var t;
    function settle() {
      var mid = scroller.scrollLeft + scroller.clientWidth / 2;
      var h = head.offsetLeft, hw = head.offsetWidth, tl = tail.offsetLeft, tw = tail.offsetWidth;
      if (mid > h && mid < h + hw) jump(last);
      else if (mid > tl && mid < tl + tw) jump(first);
    }
    scroller.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(settle, 90); }, { passive: true });
    if ('onscrollend' in window) scroller.addEventListener('scrollend', settle);
  }
  function run() { document.querySelectorAll('.product-information slideshow-slides').forEach(setup); }
  run();
  new MutationObserver(run).observe(document.querySelector('.product-information') || document.body, { childList: true, subtree: true });
})();
